// extracted by mini-css-extract-plugin
module.exports = {"heading":"PdpRespDealerDetailsStats__heading__9d1441f2","companyInfo":"PdpRespDealerDetailsStats__companyInfo__9d1441f2"};